import React, {Component} from "react";
import {Col, Modal, ModalBody, ModalHeader, Row} from 'reactstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import ToolkitProvider, {Search} from 'react-bootstrap-table2-toolkit';
import paginationFactory from 'react-bootstrap-table2-paginator';
import {errorlog, renderlog, showlog} from "../../utils/dev-utils";
import {WaitingOrNodataMessage} from "../waiting-or-nodata-message";
import {emoj} from "../../utils/string-utils";
import {EMOJ} from "../../emoj";
import {loadEvaluations} from "../../business-logic/active-service";
import {DATE_FORMAT_IT, RATING_STATUS} from "../../env";
import moment from "moment";
import {translate} from "../i18n/translate-function";


const hiddenFields = [
    "codCliFor",
    "companySize",
    "dimensionId",
    "dimensionName",
    "status",
    "dimension",
    "Id",
    "alive",
    "er_Id",
    "er_type",
    "manager",
    "assignee",
    "lastModifiedStatus"
];

const fieldMap = {
    id:             "Id",
    name:           "Nome",
    dateCreate:     "Creazione",
    state:          "Stato",
    ragioneSociale: "Azienda"
};


const LIST_LIMIT = 8;
const paginationOptions = {
    paginationSize: 2,
    pageStartIndex: 1,
    showTotal: false,
    hidePageListOnlyOnePage: false,
    paginationTotalRenderer: (from, to, size) => (
        <span className="react-bootstrap-table-pagination-total ml-2">
            Righe da {from} a {to} di {size}
        </span>
    ),
    sizePerPageList: [ LIST_LIMIT ], // A numeric array is also available. the purpose of above example is custom the text
};

const defaultSorted = [
    {
        dataField: 'id',
        order: 'asc',
    },
];

const sortableFields = [
];


const formatColumns = columnList => {
    return (
        columnList
            .map( field => {
                return ({
                    dataField: field,
                    text: fieldMap[ field ] || field,
                    sort: sortableFields.includes( field )
                });
            })
            // custom date time sort -----------------------------------------------------------------------------------
            .map( column => {
                if( ["dateCreate", "Creazione"].includes( column.dataField ) ) {
                    column.sortFunc = (a, b, order, dataField, rowA, rowB) => {
                        if (order === 'asc') {
                            return (moment(b, DATE_FORMAT_IT).unix() - moment(a, DATE_FORMAT_IT).unix());
                        }
                        return (moment(a, DATE_FORMAT_IT).unix() - moment(b, DATE_FORMAT_IT).unix());
                    }
                }
                return column;
            })
            .filter( ff => !hiddenFields.includes(ff.dataField) )
    );
}

const { SearchBar } = Search;


export default class RatingListModal extends Component {

    state = {}

    constructor( props ) {
        super( props );

        this.toggle = this.toggle.bind( this );
        this.loadData = this.loadData.bind( this );
        this.rowSelection = this.rowSelection.bind( this );
    }


    rowSelection = (row, isMain = false) => {


    }


    toggle = forceRefresh => {
        this.props.onClose( forceRefresh );
    }

    render() {


        renderlog("RatingListModal", this.state, this.props);



        let context = null;


        // if( !!this.state.data ) {
        if(!!this.state.data && this.state.data.length > 0) {




            showlog("controllo su data");
            showlog( this.state.data );


            context = (
                <ToolkitProvider
                    bootstrap4
                    keyField="id"
                    search
                    // exportCSV={{ onlyExportFiltered: true, exportAll: false }}
                >
                    {props => (
                        <React.Fragment>

                            <Row>
                                <Col>
                                    <SearchBar {...props.searchProps} />
                                </Col>
                            </Row>

                            <BootstrapTable
                                id={"ratinglist-table"}
                                bootstrap4
                                striped
                                hover
                                {...props.baseProps}
                                size="sm"
                                responsive
                                keyField="id"
                                bordered={ false }
                                data={ this.state.data }
                                columns={ formatColumns( Object.keys( this.state.data[0] ) ) }
                                defaultSorted={ defaultSorted }
                                pagination={ paginationFactory(paginationOptions) }
                                wrapperClasses="table-responsive"
                                selectRow={{
                                    mode: 'empty',
                                    clickToSelect: true,

                                    onSelect: row => {
                                        this.props.onChoose( row );
                                    },

                                    selectionRenderer: row => {
                                        return (
                                            <span className={"low-visibility"}>
                                                { emoj( EMOJ.check_mark_button )}
                                            </span>
                                        );
                                    },
                                    selectionHeaderRenderer: ({indeterminate, ...rest}) => {
                                        return null;
                                    }
                                }}

                            />


                        </React.Fragment>
                    )}
                </ToolkitProvider>
            );
        }
        else {
            context = (
                <WaitingOrNodataMessage
                    waiting={ !(!!this.state.data && this.state.data.length === 0) }
                    nodataMessage={emoj(EMOJ.sad_but_relieved_face) +"    Nessuna Valutazione"}
                />
            )
        }



        let content = (
            <Modal isOpen={ true } toggle={this.toggle}>
                <ModalHeader toggle={this.toggle} className={this.state.headerClassName}>
                    {translate("Evaluations")}
                </ModalHeader>
                <ModalBody className={this.state.bodyClass}>
                    { context }
                </ModalBody>

            </Modal>


        );


        return content;
    }

    componentDidMount() {
        this.loadData();
    }



    loadData() {

        return (

            loadEvaluations()

                // extras & adjust -------------------------------------------------------------------------------------------
                .then( list => {
                    return (
                        list
                            .map( rat => {
                                rat.dimension = rat.dimension.name;
                                return rat;
                            })
                    );
                })


                // field sort & map  -------------------------------------------------------------------------------------------
                .then( responseData => {
                    return (
                        responseData
                            .map( row => {

                                let sortedRow = {};
                                Object.keys(fieldMap)
                                    .map( field => {
                                        sortedRow[field] = row[field];
                                    })
                                ;
                                Object.assign(sortedRow, row);
                                return sortedRow;

                            })
                    );
                })


                // filter --------------------------------------------------------------------------------------------------
                .then( responseData => responseData.filter( d => d.status === RATING_STATUS.auditDone.id ) )


                // finish --------------------------------------------------------------------------------------------------
                .then( data => {
                    this.setState({
                        ...this.state,
                        data: data
                    })
                })


                .catch( e => {
                    errorlog("Caricamento Evaluations", e );
                })
        );


    }

}
